"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel/FormControlLabel.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _excluded = ["checked", "withoutBorder", "reversed", "width", "disabled", "readOnly", "margin"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var withoutBorder = _ref.withoutBorder,
        width = _ref.width,
        margin = _ref.margin;
    return {
      height: 56,
      padding: withoutBorder ? 0 : '0 16px',
      border: withoutBorder ? 'none' : "1px solid ".concat(_Colors.default.lightGrey),
      boxSizing: 'border-box',
      borderRadius: '4px',
      alignItems: 'center',
      fontFamily: 'Lato',
      display: 'flex',
      justifyContent: 'space-between',
      width: width,
      margin: margin,
      '&:focus-within': {
        border: withoutBorder ? '' : "1px solid ".concat(_Colors.default.orange),
        boxShadow: withoutBorder ? '' : '0px 0px 4px rgba(236, 105, 26, 0.4)'
      }
    };
  },
  label: function label(_ref2) {
    var checked = _ref2.checked,
        reversed = _ref2.reversed;
    return {
      fontFamily: 'Lato',
      fontSize: 15,
      fontWeight: checked ? 'bold' : 'normal',
      padding: reversed ? '0 0 0 10px' : '0 10px 0 0',
      overflow: 'hidden',
      maxHeight: '42px',
      lineHeight: '21px'
    };
  }
});

var FormControlLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var checked = _ref3.checked,
      withoutBorder = _ref3.withoutBorder,
      reversed = _ref3.reversed,
      width = _ref3.width,
      disabled = _ref3.disabled,
      readOnly = _ref3.readOnly,
      _ref3$margin = _ref3.margin,
      margin = _ref3$margin === void 0 ? '0' : _ref3$margin,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var disabledOrReadonly = disabled || readOnly;

  var _useStyles = useStyles({
    disabled: disabledOrReadonly,
    checked: checked,
    withoutBorder: withoutBorder,
    reversed: reversed,
    width: width,
    margin: margin
  }),
      root = _useStyles.root,
      label = _useStyles.label;

  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    ref: ref,
    classes: {
      root: root,
      label: label
    },
    disabled: disabledOrReadonly,
    labelPlacement: reversed ? 'end' : 'start',
    checked: checked
  }, rest));
});

var _default = FormControlLabel;
exports.default = _default;